import { ENVIRONMENT } from './config.js';

const development = {
  REACT_APP_GLOBAL_SIGNOUT_URL:
    "https://5prqwinddvlbk4yf2pup3dauoy0vsena.lambda-url.ap-south-1.on.aws",
  REACT_APP_FILE_UPLOAD_URL:
    "https://b7gihkrd57faaumq2f3gknp7na0imivy.lambda-url.ap-south-1.on.aws",
  REACT_APP_EMAIL_SETTING_URL:
    "https://ahxlnxxthhf2ma7kjno36ssae40koxvz.lambda-url.ap-south-1.on.aws/",
  REACT_APP_SIGNUP_CHECK:
    "https://bxucs7zcvsocygyw77ktcxnzvi0xjqsf.lambda-url.ap-south-1.on.aws",
  REACT_APP_SIGNUP_CHECK2:
    "https://j6uoqeebft7cebrfkn4ct6pxom0qxluz.lambda-url.ap-south-1.on.aws",
  REACT_APP_FETCH_GSTIN_URL:
    "https://qqf4eb3m3r7mjinul5y227slvq0gpkjk.lambda-url.ap-south-1.on.aws",
  GENERATE_PDF:
    "https://gnlahy34spdmlocftoikktbzdu0hopgz.lambda-url.ap-south-1.on.aws/",
  REACT_APP_EXPORT_URL:
    "https://b7e567lgysvdgwxvezz574m4bq0crdbl.lambda-url.ap-south-1.on.aws/",
  REACT_APP_EXPORT_SELECTION_URL:
    "https://d5hwuua5fbzyeckedksyhkd74i0mmgsa.lambda-url.us-east-1.on.aws",
  REACT_APP_EXPORT_DATA_URL:
    "https://efffooopg7ocgbdsemkqauadkm0lsdnp.lambda-url.ap-south-1.on.aws",
  REACT_APP_IFSC_FETCH:
    "https://a7cpejsthfojrlpidfnz56rvia0qycxy.lambda-url.ap-south-1.on.aws/",
  IMPORT_EXCEL_FROM_S3_URL:
    "https://iot33dxh2tgbo56nzlzgxxuwvu0mlmvb.lambda-url.ap-south-1.on.aws/",
  IMPORT_DATA_URL:
    "https://7527xbbtf2dcehp2rv2yjvvvq40fewyt.lambda-url.ap-south-1.on.aws/",
  REACT_APP_SEND_OTP_URL:
    "https://vt2c4iqvl7zvynvebjmuq2pbgy0qzktu.lambda-url.ap-south-1.on.aws/",
  REACT_APP_SUPPORT_URL:
    "https://qshfmdjpcnsjmp5kditiy74odi0emuan.lambda-url.ap-south-1.on.aws",
  REACT_APP_PASSWORD_ROTATION:
    "https://ubjnrcwppl26q67pqdixpgea3y0ynbia.lambda-url.ap-south-1.on.aws/",
  GENERATE_PDF_PDFKIT:
    "https://gnlahy34spdmlocftoikktbzdu0hopgz.lambda-url.ap-south-1.on.aws/",
  EMAIL_SENDING_URL:
    "https://vta5grtaj77n7nv7zylbxqaqya0kmtfc.lambda-url.ap-south-1.on.aws/",
  REACT_APP_EINVOICE_URL:
    "https://6phffqbrsgkcaynra3ruovmxhy0nzfnv.lambda-url.ap-south-1.on.aws/",
  REACT_APP_EWAYBILL_URL:
    "https://lheyoltrvxmzlvkpahg33ioinu0xdesl.lambda-url.ap-south-1.on.aws/",
  REACT_APP_AIBLINK_URL:
    "https://5ehd3wdrsjlqawrxnukalfb5ga0jgrks.lambda-url.ap-south-1.on.aws/",
  REACT_APP_S3_BUCKET_URL: "https://ledgerx365beta.s3.amazonaws.com",
  EXPORT:'https://hntuuugo3ixk2jtas3nclxqdku0jfvob.lambda-url.ap-south-1.on.aws/',
  CHAT_API_URL: 'http://localhost:8000/chatbot',
  NEST_BASE_URL: 'https://api.dev.ledgerx365.com/',
  // NEST_BASE_URL: 'http://localhost:3001/',
};
const QA = {
  REACT_APP_GLOBAL_SIGNOUT_URL: 'https://tejfp5zvi57z6oda3hbhlgmlki0mxdbb.lambda-url.ap-south-1.on.aws',
  REACT_APP_FILE_UPLOAD_URL: 'https://qstijjl6yvjqhxw7gnyl5jmyom0jiqqp.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EMAIL_SETTING_URL: 'https://vpseqygpmokscinsspsrpp3yne0kogez.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK2: 'https://wxg5uvm54z43suhdqkqb6xhaki0ojhyw.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK: 'https://jedyu7u7s4qmjddxc6y6agf2dy0mmvht.lambda-url.ap-south-1.on.aws/',
  REACT_APP_FETCH_GSTIN_URL: 'https://bv3yiqbshze6lpo5gheqr3mamm0hegid.lambda-url.ap-south-1.on.aws/',
  REACT_APP_GENERATE_PDF: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws',
  REACT_APP_EXPORT_URL: 'https://bhkwlbg7qb36ssxu3zmuha6kfi0azqes.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EXPORT_SELECTION_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_EXPORT_DATA_URL: 'https://bok7xu5shdohd4soi4j5vzn3kq0kimrp.lambda-url.ap-south-1.on.aws/',
  REACT_APP_IFSC_FETCH: 'https://tfa57j7ae6pdsuk2zmh37j3j4a0ylqvr.lambda-url.ap-south-1.on.aws',
  IMPORT_EXCEL_FROM_S3_URL: 'https://hk74uv6v2sjatuzhbrg64cg2xy0wxmbe.lambda-url.ap-south-1.on.aws/',
  IMPORT_DATA_URL: 'https://se5lroh6gsn7r6z2mnt4kraqk40kkbtw.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SEND_OTP_URL: 'https://47cusz6g5pzl5rlphwug7sqwg40iimyb.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SUPPORT_URL: 'https://i7dg7yd6gdd447i7nwck4znklq0edbbg.lambda-url.ap-south-1.on.aws/',
  REACT_APP_PASSWORD_ROTATION: 'https://cglrlavdh4gp6a7nmjmxjkvzsu0zqwux.lambda-url.ap-south-1.on.aws/',
  GENERATE_PDF_PDFKIT: 'https://lrwl5yn6r5i6zsdoelnstxupfy0rfiki.lambda-url.ap-south-1.on.aws/',
  EMAIL_SENDING_URL: 'https://eevs5d2rottonlmdjsdbnl75fa0vpdjx.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EINVOICE_URL: 'https://k7ohy4sj3en33mrrxufaed357u0cwvwx.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EWAYBILL_URL: 'https://mwyghmhkmkz4bfu4gywuxgxo440xizbr.lambda-url.ap-south-1.on.aws/',
  REACT_APP_AIBLINK_URL: 'https://5ehd3wdrsjlqawrxnukalfb5ga0jgrks.lambda-url.ap-south-1.on.aws/',
  REACT_APP_S3_BUCKET_URL: 'https://ledgerx365qa.s3.amazonaws.com',
  EXPORT: 'https://vemlwnndpcjzbiookfm2o67ab40kpvxo.lambda-url.ap-south-1.on.aws/',
  CHAT_API_URL: 'https://api.qa.ledgerx365.com/chatbot',
  NEST_BASE_URL: 'https://api.qa.ledgerx365.com/',
};

const beta = {
  REACT_APP_GLOBAL_SIGNOUT_URL: 'https://tejfp5zvi57z6oda3hbhlgmlki0mxdbb.lambda-url.ap-south-1.on.aws',
  REACT_APP_FILE_UPLOAD_URL: 'https://rxgd3iilbm2oxvhxqags2mbvca0pfgbv.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EMAIL_SETTING_URL: 'https://7qneqy5kzq4szbojeavtst6c4y0crcgu.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK2: 'https://u7p2bhvzben4c57cu5smzq23ya0niael.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK: 'https://bok7rar7kpgkfpgctu62qwombi0cyowa.lambda-url.ap-south-1.on.aws/',
  REACT_APP_FETCH_GSTIN_URL: 'https://rrihigfj2m6jcgibo5a6boimjq0cpxse.lambda-url.ap-south-1.on.aws/',
  REACT_APP_GENERATE_PDF: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws',
  REACT_APP_EXPORT_URL: 'https://l32thzzyazaefj5kc6mat7lnq40hslgc.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EXPORT_SELECTION_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_EXPORT_DATA_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_IFSC_FETCH: 'https://oluxwvbe6yycutwjvdz7bki5fy0cxvib.lambda-url.ap-south-1.on.aws/',
  IMPORT_EXCEL_FROM_S3_URL: 'https://ypjs7raawpwb6r2bmfyy5d7t3q0playd.lambda-url.ap-south-1.on.aws/',
  IMPORT_DATA_URL: 'https://uevzpzk6cxo3scphsbzv6t7ol40iwuyh.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SEND_OTP_URL: 'https://cjtduuue3u2wile3ivud2yapfu0tqkzd.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SUPPORT_URL: 'https://hesbhs2paijwdi3xggvexxnfni0hhxpt.lambda-url.ap-south-1.on.aws/',
  REACT_APP_PASSWORD_ROTATION: 'https://cglrlavdh4gp6a7nmjmxjkvzsu0zqwux.lambda-url.ap-south-1.on.aws/',
  GENERATE_PDF_PDFKIT: 'https://njamf4uqqk4htljunkpp2xxwbq0uhctw.lambda-url.ap-south-1.on.aws/',
  EMAIL_SENDING_URL: 'https://ozxdkyjsfkurbuhodnktnwz6hi0uxfwy.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EINVOICE_URL: 'https://q7t6szmt64drgvr5z53d2432sq0qoiji.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EWAYBILL_URL: 'https://fiwbibvv7qzgpjmq5x6xqv34ca0sbymi.lambda-url.ap-south-1.on.aws/',
  REACT_APP_AIBLINK_URL: 'https://5ehd3wdrsjlqawrxnukalfb5ga0jgrks.lambda-url.ap-south-1.on.aws/',
  REACT_APP_S3_BUCKET_URL: 'https://ledgerx365beta.s3.amazonaws.com',
  EXPORT: 'https://pxeqnxdf3bt7ymkqiaiyck3sna0vpcxb.lambda-url.ap-south-1.on.aws/',
  CHAT_API_URL: 'https://api.beta.ledgerx365.com/chatbot',
  NEST_BASE_URL: 'https://api.beta.ledgerx365.com/',
};
const security = {
  REACT_APP_GLOBAL_SIGNOUT_URL: 'https://rmmqrtxhb636crqh3yrysz74ji0zardd.lambda-url.ap-south-1.on.aws/',
  REACT_APP_FILE_UPLOAD_URL: 'https://pe3iq74memyr6ncdm3ersqlqtm0cxpej.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EMAIL_SETTING_URL: 'https://ejo7jjzuqah3cgivu4p7fes3fi0mvoaw.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK: 'https://rqtw5bvgnupjftxm6jwn26fy3y0edyna.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK2: 'https://ooe36xskmogptfscwqsco6vpq40bvkcn.lambda-url.ap-south-1.on.aws/',
  REACT_APP_FETCH_GSTIN_URL: 'https://52qilyx63hf6tv2mvp52ut7hzi0vpuln.lambda-url.ap-south-1.on.aws/',
  REACT_APP_GENERATE_PDF: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws',
  REACT_APP_EXPORT_URL: 'https://k5nex4eu2jpcbexngtrf7h7gk40grdmc.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EXPORT_SELECTION_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_EXPORT_DATA_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_IFSC_FETCH: 'https://o4amneypngbk7oyj2fgnl36m3m0rbrni.lambda-url.ap-south-1.on.aws/',
  IMPORT_EXCEL_FROM_S3_URL: 'https://u644ftwpsurtxsdue42maex66y0mxvii.lambda-url.ap-south-1.on.aws/',
  IMPORT_DATA_URL: 'https://kupstob4yn27oninpw74kfy4gy0dvjto.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SEND_OTP_URL: 'https://6w3f2aqa7hv774ndqfj7jkbnli0xcdwo.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SUPPORT_URL: 'https://2prrptv6cu5uh4c7ezur4nt3mi0hwnao.lambda-url.ap-south-1.on.aws/',
  REACT_APP_PASSWORD_ROTATION: 'https://m5an75g3uavmrb65fccvvte35e0ebyls.lambda-url.ap-south-1.on.aws/',
  GENERATE_PDF_PDFKIT: 'https://zwp3jixeiifnibpvu47zc7vism0zqicm.lambda-url.ap-south-1.on.aws/',
  EMAIL_SENDING_URL: 'https://kgtttyvuicvvbip533rursxopi0mnoez.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EINVOICE_URL: 'https://chh7ewuvrg42l7e7yvp6c7ivyi0fycmv.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EWAYBILL_URL: 'https://m7cfzh5odr2p2mcvpyk3jop47a0grfvz.lambda-url.ap-south-1.on.aws/',
  REACT_APP_AIBLINK_URL: 'https://5ehd3wdrsjlqawrxnukalfb5ga0jgrks.lambda-url.ap-south-1.on.aws/',
  REACT_APP_S3_BUCKET_URL: 'https://ledgerx365sit.s3.amazonaws.com',
  EXPORT: 'https://pxeqnxdf3bt7ymkqiaiyck3sna0vpcxb.lambda-url.ap-south-1.on.aws/',
  CHAT_API_URL: 'https://api.beta.ledgerx365.com/chatbot',
  NEST_BASE_URL: 'https://api.beta.ledgerx365.com/',
};
const production = {
  REACT_APP_GLOBAL_SIGNOUT_URL: 'https://tejfp5zvi57z6oda3hbhlgmlki0mxdbb.lambda-url.ap-south-1.on.aws',
  REACT_APP_FILE_UPLOAD_URL: 'https://lvpac2434gxvuhl4xkx673tyhu0snvbp.lambda-url.ap-south-1.on.aws',
  REACT_APP_EMAIL_SETTING_URL: 'https://5bqadc222otxxzfd27cpap6gje0lrwnv.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SIGNUP_CHECK: 'https://wzsmjn2jmxup5r33rqp47czsiu0dttqh.lambda-url.ap-south-1.on.aws',
  REACT_APP_SIGNUP_CHECK2: 'https://6mb5qjazjw7z7yraghnxq53pea0dhauv.lambda-url.ap-south-1.on.aws/',
  REACT_APP_FETCH_GSTIN_URL: 'https://czvmlkgra6usjhcpex2y4cisxe0xdpuj.lambda-url.ap-south-1.on.aws',
  REACT_APP_GENERATE_PDF: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws',
  REACT_APP_EXPORT_URL: 'https://7chn42zqozoi2w7s2t5bn4sdai0axqrh.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EXPORT_SELECTION_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_EXPORT_DATA_URL: 'https://h4iu6ux3b5dxdclw5o7k2vaqsi0fbtbb.lambda-url.us-east-1.on.aws',
  REACT_APP_IFSC_FETCH: 'https://qpp6dd5tpie34c4g2rnn44idui0ehqln.lambda-url.ap-south-1.on.aws',
  IMPORT_EXCEL_FROM_S3_URL: 'https://mrdpusnvyurbiqszr7nqkujt540apxpm.lambda-url.us-east-1.on.aws',
  IMPORT_DATA_URL: 'https://eymdgx4ru46v2cv5yaaog3sz340mspdg.lambda-url.us-east-1.on.aws',
  REACT_APP_SEND_OTP_URL: 'https://wi7tnzfwt6qdf6eltyf2d4wrse0htgth.lambda-url.ap-south-1.on.aws/',
  REACT_APP_SUPPORT_URL: 'https://zmm5irya7bhpewefhw4oksvwga0rltyb.lambda-url.ap-south-1.on.aws',
  REACT_APP_PASSWORD_ROTATION: 'https://cglrlavdh4gp6a7nmjmxjkvzsu0zqwux.lambda-url.ap-south-1.on.aws/',
  GENERATE_PDF_PDFKIT: 'https://7peijgtztetsougeypy5od2bse0cxfjz.lambda-url.ap-south-1.on.aws/',
  EMAIL_SENDING_URL: 'https://cnm3c5kfyaf3ru3i4b7fugkily0dhnje.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EINVOICE_URL: 'https://25va4zit4wfpsd35zlgxjlsg4i0ibhbm.lambda-url.ap-south-1.on.aws/',
  REACT_APP_EWAYBILL_URL: 'https://7hewkjg4tlzjg77a6tbtgy36m40cpwel.lambda-url.ap-south-1.on.aws/',
  REACT_APP_AIBLINK_URL: 'https://5ehd3wdrsjlqawrxnukalfb5ga0jgrks.lambda-url.ap-south-1.on.aws/',
  REACT_APP_S3_BUCKET_URL: 'https://ledgerx365.s3.amazonaws.com',
  EXPORT: 'https://khnt2hecuyaboeuu3idh7ienba0lopqp.lambda-url.ap-south-1.on.aws/',
  CHAT_API_URL: 'https://api.ledgerx365.com/chatbot',
  NEST_BASE_URL: 'https://api.ledgerx.biz/',
};

const API_ENDPOINTS =
  {
    development,
    QA,
    beta,
    security,
    production,
  }[ENVIRONMENT] || development;

export default API_ENDPOINTS;
